import { OpsDatasetsLayoutComponent } from 'app/components/ops-datasets/OpsDatasetsLayoutComponent'

export const handle = {
  title: `Datasets`,
  breadcrumb: `Datasets`,
}

export default function OpsDatasetsLayout(): React.ReactElement {
  return <OpsDatasetsLayoutComponent />
}
